import { SetStateAction, useCallback } from 'react'
import { ModalDeleteFilledOutside } from '../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { UpdateTaskTy } from '../../../types'
import { ModalSmallFilledOutside } from '../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'

interface ModalTaskDeleteProps extends ModalTaskDeleteLogicProps {
    opened: true | null
    setOpened: React.Dispatch<SetStateAction<true | null>>
    is_deleted: boolean
}

const ModalTaskDelete: React.FC<ModalTaskDeleteProps> = ({ is_deleted, ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleDelete, handleRecover } = useModalTaskDeleteLogic({ ...rest })
    if (is_deleted) {
        return (
            <ModalSmallFilledOutside translations={{
                title: t('recoverTask', 'Recuperar tarea'),
                subtitle: t('recoverTaskExp', '¿Estás seguro de recuperar esta tarea?'),
                buttonAccept: t('recover', 'Recuperar')
            }} onAccept={handleRecover} {...rest} />
        )
    }
    return (
        <ModalDeleteFilledOutside translations={{
            title: t('deleteTask', 'Eliminar tarea'),
            subtitle: t('areYouSureToDeleteThisTaskExp', '¿Estás seguro de eliminar esta tarea y sus subtareas?'),
            buttonAccept: t('delete', 'Eliminar')
        }} onAccept={handleDelete} {...rest} />
    )
}

interface ModalTaskDeleteLogicProps {
    updateTask: UpdateTaskTy
    onDeletedTask: () => void
}

const useModalTaskDeleteLogic = ({ updateTask, onDeletedTask }: ModalTaskDeleteLogicProps) => {
    const handleDelete = useCallback(async () => {
        await updateTask('deleted', true)
        onDeletedTask()
    }, [updateTask, onDeletedTask])

    const handleRecover = useCallback(async () => {
        await updateTask('deleted', false)
    }, [updateTask])

    return { handleDelete, handleRecover }
}


export default ModalTaskDelete